module.exports = __webpack_public_path__ + "assets/img/home-zhaoshang-light.c1bba583.png";